(function ($) {
    /* Document ready functions */
    $(document).ready(function () {


      $('.show-all-btn').on('click', function(){
  			$(this).siblings().first().children().trigger('click');
  		});

      $('.home .images .txt-overlay .fade').featherlight('iframe');

    });

})(jQuery);
